<template>
  <a-select
    show-search
    allowClear
    v-model="selectValue"
    :placeholder="placeholder"
    option-filter-prop="children"
    :filter-option="filterOption"
    :disabled="disabled"
    style="width: 100%"
    @change="handleChange"
  >
    <a-select-option
      v-for="item in optionList"
      :key="item.id"
      :value="item.id">
      {{ item.org }}
    </a-select-option>
  </a-select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProjectSelect',
  props: {
    value: {
      type: [String, Array, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    allowClear: {
      type: Boolean,
      required: false,
      default: true
    },
    placeholder: {
      type: String,
      default: () => '请选择'
    },
    option: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // selectValue: this.multiple ? [] : ''
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    ...mapGetters(['lineListEnum']),
    optionList() {
      return this.option.length > 0 ? this.option : this.lineListEnum
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  }
}
</script>

<style lang="less" scoped>
</style>
